import { gql } from '@apollo/client';

export const REMOVE_OFFENSE_FROM_INCIDENT = gql`
mutation removeOffenseFromIncident($input: RemoveOffenseFromIncidentInput!) {
  removeOffenseFromIncident(input: $input) {
    __typename
    clientMutationId
    errors
    incidentOffenseUuid
  }
}
`
